import extendNode from '../extendNode.mjs'
import {insertModuleTypes, menuItemsInsertModule} from '../menuItemsInsert.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaIsrfreqTarmodule.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canLinkType(map, node, type) {
            const {moduleType} = node.parent.data

            if (moduleType) {
                return moduleType === type
            }
            else {
                return insertModuleTypes.includes(type)
            }
        },

        canWriteTree(map, node) {
            const {reqType} = node.parent.data
            return 'ADD' === reqType
        },

        menuItemsInsertProduct(map, node) {
            const {moduleType, reqType} = node.parent.data

            if ('ADD' !== reqType) {
                return []
            }

            if (moduleType) {
                return [{type: moduleType}]
            }
            else {
                return menuItemsInsertModule(map)
            }
        },

        _onAttach(map, node, event) {
            node.parent.data.moduleType = event.target.data.bizNodeType

            for (const n of [...node.children].slice(0, -1)) {
                map.deleteTree(n)
            }
        },

        _onInsert(map, node, event) {
            node.parent.data.moduleType = event.target.data.bizNodeType

            for (const n of [...node.children].slice(0, -1)) {
                map.deleteTree(n)
            }
        },
    })
}
